export const PLAN_MENU_OPTIONS = [
  { key: 'dealership', value: 'Edit Dealerships' },
  { key: 'journey', value: 'Edit Journeys' },
  { key: 'story', value: 'Edit Stories' },
  { key: 'plan', value: 'Delete Plan' },
  { key: 'config', value: 'Configure Authentication' },
];
